import { useEffect, useRef, useState } from 'react'
import ContentHeader from '../components/ContentHeader'
import Loader from '../components/Loading'
import { getCrmServiceUrl } from '../utils/backend'
import { getAuthHeaders, getSessionAuth } from '../utils/sessionAuth'
import { ensureSessionUserId, getSessionUserId } from '../utils/sessionUser'

function CatalogRawView() {
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [pdfUrl, setPdfUrl] = useState<string | null>(null)
  const pdfUrlRef = useRef<string | null>(null)

  useEffect(() => {
    let cancelled = false

    const loadRawCatalog = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const existingUserId = getSessionUserId()
        const userId = existingUserId || (await ensureSessionUserId(getSessionAuth()))
        if (!userId) {
          throw new Error('Unable to resolve the current user.')
        }

        const resp = await fetch(`${getCrmServiceUrl()}/catalog/${encodeURIComponent(userId)}/raw`, {
          headers: getAuthHeaders(),
          credentials: 'include',
        })
        if (!resp.ok) {
          throw new Error('Unable to load the raw catalog PDF.')
        }

        const blob = await resp.blob()
        const nextUrl = URL.createObjectURL(blob)

        if (cancelled) {
          URL.revokeObjectURL(nextUrl)
          return
        }

        if (pdfUrlRef.current) {
          URL.revokeObjectURL(pdfUrlRef.current)
        }
        pdfUrlRef.current = nextUrl
        setPdfUrl(nextUrl)
      } catch (err) {
        if (!cancelled) {
          console.error('Failed to load raw catalog', err)
          setError(err instanceof Error ? err.message : 'Unable to load the raw catalog PDF.')
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false)
        }
      }
    }

    loadRawCatalog()

    return () => {
      cancelled = true
      if (pdfUrlRef.current) {
        URL.revokeObjectURL(pdfUrlRef.current)
        pdfUrlRef.current = null
      }
    }
  }, [])

  return (
    <>
      <ContentHeader title="Raw Catalog" />
      <div className="content-panel">
        <div className="card">
          {isLoading ? (
            <Loader />
          ) : error ? (
            <div className="muted">{error}</div>
          ) : pdfUrl ? (
            <iframe
              title="Raw Catalog PDF"
              src={pdfUrl}
              style={{ width: '100%', minHeight: '80vh', border: 'none', borderRadius: '16px' }}
            />
          ) : (
            <div className="muted">No raw catalog available.</div>
          )}
        </div>
      </div>
    </>
  )
}

export default CatalogRawView
